import React, { useState } from "react";
import { Tooltip, message } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

// Shows a value with a copy icon that appears on hover.
const CopyText = ({ value, children }) => {
    const [copied, setCopied] = useState(false);
    if (!value) return <span>—</span>;

    const copy = async (e) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(String(value));
            setCopied(true);
            message.success("Copied");
            setTimeout(() => setCopied(false), 1500);
        } catch {
            message.error("Copy failed");
        }
    };

    return (
        <span className="copy-text">
            {children ?? value}
            <Tooltip title={copied ? "Copied" : "Copy"}>
                <span className="copy-text__btn" onClick={copy}>
                    {copied ? <CheckOutlined /> : <CopyOutlined />}
                </span>
            </Tooltip>
        </span>
    );
};

export default CopyText;
